import { render, staticRenderFns } from "./ImportFromExcel.vue?vue&type=template&id=35d73722&scoped=true&"
import script from "./ImportFromExcel.vue?vue&type=script&lang=js&"
export * from "./ImportFromExcel.vue?vue&type=script&lang=js&"
import style0 from "./ImportFromExcel.vue?vue&type=style&index=0&id=35d73722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d73722",
  null
  
)

/* custom blocks */
import block0 from "./ImportFromExcel.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./ImportFromExcel.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCardText,VDataTable,VIcon,VRadio,VRadioGroup,VRow})
